export const DEBOUNCE_TIMEOUT_MS = 300
export const FALLBACK_TIMEOUT_MS = 1000
